/* Breggz teaser motion layer — parallax + staggered reveal.
   Additive, auto-tagging, fully disabled under prefers-reduced-motion. */
(function () {
  var COVER_SCALE = 1.18;          // must match .css [data-brz-parallax] scale
  var FLOAT_RANGE = 300;           // px of travel at depth 1.0 for in-flow images
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- auto-tagging ---------- */

  function tagFloats(root) {
    var sel = '.fill-img img, .highlight_image img, .about_us img, ' +
              '.newsletter img, [class*="container-"] .side img';
    root.querySelectorAll(sel).forEach(function (img, i) {
      if (img.closest('.custom-banner_img') || img.closest('.mini-banner-img')) return;
      if (img.hasAttribute('data-brz-float') || img.hasAttribute('data-brz-parallax')) return;
      // 'the idea' tiles: drift the whole tile, not the image inside it.
      // .fill-img is overflow:hidden AND carries the clip-path wipe, and its
      // box is exactly as tall as the image, so a float on the <img> slides
      // the picture out of its own clip — up to a third of the small tiles
      // was being sliced off at the extremes of the scroll.
      var target = img.closest('.c_grid .fill-img') ? img.closest('.grid-item') || img : img;
      if (target.hasAttribute('data-brz-float')) return;
      // alternate depths so neighbouring images drift apart, not in lockstep
      var depths = [0.055, 0.115, 0.075, 0.145];
      target.setAttribute('data-brz-float', depths[i % depths.length]);
    });
  }

  function tagReveals(root) {
    var sel = '.content, .intro, .mini-banner-quote, .highlights_item, .highlights_title, ' +
              '.fill-img, .highlight_image, .about_us .side > div, .newsletter img, ' +
              '.brz-footer-cols .links, .custom-banner_heading > div > *';
    root.querySelectorAll('.shopify-section').forEach(function (sec) {
      var n = 0;
      sec.querySelectorAll(sel).forEach(function (el) {
        if (el.classList.contains('brz-reveal') || el.classList.contains('brz-reveal-media')) { n++; return; }
        if (el.parentElement && el.parentElement.closest('.brz-reveal,.brz-reveal-media')) return;
        // photography wipes open; type rises. Two motions, not one.
        var isMedia = /fill-img|highlight_image/.test(el.className) ||
                      (el.tagName === 'IMG' && !el.closest('.custom-banner_heading'));
        el.classList.add(isMedia ? 'brz-reveal-media' : 'brz-reveal');
        el.style.setProperty('--brz-i', String(n % 5));
        n++;
      });
      // anything already on screen at boot appears without animating
      sec.querySelectorAll('.brz-reveal,.brz-reveal-media').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.9) el.classList.add('is-in');
      });
    });
  }


  /* ---------- hero chrome: scroll cue + header state ---------- */

  var heroSection = null;

  // the header floats over the hero; publish its height so CSS can offset
  function measureHeader() {
    var hdr = document.querySelector('.section-header');
    if (!hdr) return;
    document.documentElement.style.setProperty(
      '--brz-header-h', Math.round(hdr.getBoundingClientRect().height) + 'px');
  }

  function initHeroChrome() {
    measureHeader();
    window.addEventListener('resize', measureHeader);
    heroSection = document.querySelector('[id$="__hero"]');
    if (!heroSection) return;
    if (!heroSection.querySelector('.brz-scrollcue')) {
      var cue = document.createElement('span');
      cue.className = 'brz-scrollcue';
      cue.setAttribute('aria-hidden', 'true');
      heroSection.appendChild(cue);
    }
    syncHeader();
  }

  // header sits transparent over the hero, then solidifies
  function syncHeader() {
    if (!heroSection) return;
    var h = heroSection.getBoundingClientRect().bottom;
    document.body.classList.toggle('brz-hero-top', h > 90);
  }

  /* ---------- descriptive alt text ---------- */

  function describeImages(root) {
    root.querySelectorAll('.shopify-section img').forEach(function (img) {
      if (img.alt) return;
      var sec = img.closest('.shopify-section');
      var h = sec && sec.querySelector('h2,h3,h4');
      var label = h ? h.textContent.trim() : '';
      if (img.closest('.custom-banner_heading')) { img.alt = 'Breggz'; return; }
      img.alt = label ? label.replace(/\s+/g, ' ') : '';
    });
  }

  /* ---------- parallax ---------- */

  var items = [];
  var stack = [];
  var ticking = false;

  /* The three full-bleed bands are `position:sticky; top:0` with rising
     z-index, so each one pins and the next rides over it. Two consequences
     the generic parallax model above cannot see:

       - a pinned element's getBoundingClientRect().top is frozen at 0, so
         its parallax stopped moving for exactly as long as the visitor was
         looking at it;
       - "how far through this band am I" is not a viewport question once it
         is pinned, it is "how much of me has the next band covered".

     So a sticky band is measured against its own successor instead. Detected
     from the computed style rather than from the section keys, so a renamed
     or reordered band keeps working, and reduced motion (which drops them
     back to `position:relative` in CSS) opts out by itself. */
  function collect() {
    items = [].slice.call(document.querySelectorAll('[data-brz-parallax],[data-brz-float]'));
    stack = [];
    [].slice.call(document.querySelectorAll('section.mini-banner')).forEach(function (sec) {
      if (getComputedStyle(sec).position !== 'sticky') return;
      var next = sec.nextElementSibling;
      while (next && next.getBoundingClientRect().height === 0) next = next.nextElementSibling;
      stack.push({ sec: sec, next: next, dim: sec.querySelector('.brz-dim') });
      sec.__brzStack = true;
    });
  }

  // 0 while the band is uncovered, 1 once the next band has fully covered it
  function coverOf(entry) {
    if (!entry.next) return 0;
    var h = entry.sec.getBoundingClientRect().height;
    if (!h) return 0;
    var c = (h - entry.next.getBoundingClientRect().top) / h;
    return c < 0 ? 0 : c > 1 ? 1 : c;
  }

  function stackFrame(vh) {
    for (var i = 0; i < stack.length; i++) {
      var e = stack[i];
      var r = e.sec.getBoundingClientRect();
      if (r.bottom < -300 || r.top > vh + 300) continue;
      var approach = (vh - r.top) / vh;          // 0 entering .. 1 pinned
      if (approach < 0) approach = 0;
      if (approach > 1) approach = 1;
      var c = coverOf(e);
      // one continuous 0..1 travel: half of it approaching, half being covered
      e.sec.__brzT = 0.5 * approach + 0.5 * c;
      e.sec.style.setProperty('--brz-cover', c.toFixed(3));
    }
  }

  function frame() {
    var vh = window.innerHeight;
    stackFrame(vh);
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      var cover = el.hasAttribute('data-brz-parallax');
      var host = cover ? (el.closest('.shopify-section') || el.parentElement) : el;
      var r = host.getBoundingClientRect();
      if (r.bottom < -300 || r.top > vh + 300) continue;

      // -1 fully below the fold .. +1 fully above it
      var progress;
      if (host.__brzStack && typeof host.__brzT === 'number') {
        progress = host.__brzT * 2 - 1;         // keeps travelling while pinned
      } else {
        progress = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
      }
      if (progress > 1) progress = 1;
      if (progress < -1) progress = -1;

      if (cover) {
        var depth = parseFloat(el.getAttribute('data-brz-parallax')) || 0.35;
        // never travel further than the scale overflow, or the image edge shows
        var amp = (COVER_SCALE - 1) / 2 * r.height * Math.min(1, depth / 0.5);
        el.style.transform = 'translate3d(0,' + (-progress * amp).toFixed(2) +
                             'px,0) scale(' + COVER_SCALE + ')';
      } else {
        var d = parseFloat(el.getAttribute('data-brz-float')) || 0.08;
        el.style.transform = 'translate3d(0,' + (-progress * d * FLOAT_RANGE).toFixed(2) + 'px,0)';
      }
    }
    sweepReveals(vh);
    syncHeader();
    ticking = false;
  }

  // belt-and-braces: IntersectionObserver can miss programmatic/instant scrolls
  var pending = null;
  function sweepReveals(vh) {
    if (pending === null) pending = [].slice.call(document.querySelectorAll('.brz-reveal,.brz-reveal-media'));
    if (!pending.length) return;
    var still = [];
    for (var i = 0; i < pending.length; i++) {
      var el = pending[i];
      if (el.classList.contains('is-in')) continue;
      var rr = el.getBoundingClientRect();
      // a 0-height target is un-observable and un-revealable; show it rather
      // than let it sit clipped with an image that will never load
      if (rr.top < vh * 0.9 || rr.height === 0) el.classList.add('is-in');
      else still.push(el);
    }
    pending = still;
  }

  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(frame); }
  }

  /* ---------- reveal ---------- */

  function initReveal() {
    var els = [].slice.call(document.querySelectorAll('.brz-reveal:not(.is-in),.brz-reveal-media:not(.is-in)'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce.matches) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
      // threshold 0, not 0.05: a target whose box is still 0px tall (image not
      // decoded yet) can never reach a 5% ratio, so it would stay clipped for
      // ever and its lazy image would never be fetched. threshold 0 fires on
      // contact, which is what a wipe-in wants anyway.
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- client review 2026-09-04 ---------- */

  /* "Can we change the look of the warning notice to fill in an email?"
     The browser's own bubble cannot be styled, so the form opts out of
     native validation and the message is written into the page instead.
     The check is format-only. Refusing an address that is well-formed but
     undeliverable is a deliverability question with a cost attached, and it
     is still open - see docs/open-questions.md. */
  // stricter than the browser, which accepts "a@b": require a real domain
  var EMAIL = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

  function initSignupValidation(root) {
    (root || document).querySelectorAll('form.newsletter-form').forEach(function (form) {
      if (form.hasAttribute('data-brz-validated')) return;
      var input = form.querySelector('input[type="email"]');
      if (!input) return;
      form.setAttribute('data-brz-validated', '');
      form.setAttribute('novalidate', 'novalidate');

      var field = input.closest('.field');
      var button = form.querySelector('button[type="submit"]');
      // must sit outside .field: that is the flex row holding the input,
      // the label and the JOIN button, and a fifth item there squeezes
      // the input to a stub and parks the message beside the button
      var host = form.querySelector('.newsletter-form__field-wrapper')
              || field || input.parentElement;
      // Shopify's own message when the post round-trips. It says the same
      // thing in its own words, so it is retired the moment this script
      // takes over the field and cannot linger next to a second one.
      var served = host.querySelector('.newsletter-form__message:not(.newsletter-form__message--success)');

      var slot = document.createElement('small');
      slot.className = 'brz-field-error';
      slot.setAttribute('role', 'alert');
      slot.id = (input.id || 'brz-signup') + '-brz-error';
      host.appendChild(slot);

      // once the visitor has been told, tell them again as they correct it
      var live = false;

      function clear() {
        slot.textContent = '';
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
        if (field) field.classList.remove('is-invalid');
        if (served) { served.remove(); served = null; }
      }
      function fail(message, focus) {
        if (served) { served.remove(); served = null; }
        slot.textContent = message;
        input.setAttribute('aria-invalid', 'true');
        input.setAttribute('aria-describedby', slot.id);
        if (field) field.classList.add('is-invalid');
        live = true;
        if (focus) input.focus({ preventScroll: true });
      }
      function check(focus) {
        var value = input.value.trim();
        if (input.value !== value) input.value = value;   // a pasted address keeps its spaces
        if (!value) { fail('Please enter your email address.', focus); return false; }
        if (!EMAIL.test(value)) { fail('That does not look like an email address.', focus); return false; }
        clear();
        return true;
      }

      // the round-trip left the field marked invalid and JS is running now,
      // so adopt that state rather than showing a second, unstyled message
      if (served || input.getAttribute('aria-invalid') === 'true') {
        fail('That does not look like an email address.', false);
      }

      input.addEventListener('input', function () { if (live) check(false); else clear(); });
      form.addEventListener('submit', function (e) {
        if (!check(true)) { e.preventDefault(); return; }
        // Busy is a state, never a block. Shopify's spam protection
        // intercepts this same event, cancels it, fetches a captcha token
        // and re-submits, so a script-side "already sending" guard would
        // swallow the real post. The button stops taking clicks through
        // CSS, which is what actually stops a double-tap, and Shopify
        // upserts a subscriber by address, so a repeat is not a duplicate.
        form.setAttribute('data-brz-sending', '');
        if (button) button.setAttribute('aria-busy', 'true');
        // nothing navigated: a challenge, or the network dropped it
        setTimeout(release, 6000);
      });

      function release() {
        form.removeAttribute('data-brz-sending');
        if (button) button.removeAttribute('aria-busy');
      }
      // coming back through history restores the busy state with the page
      window.addEventListener('pageshow', release);
    });
  }

  /* Which market a sign-up came from, for the CRM. Asked for by Pierre on
     2026-09-08, using the endpoint Dominik found.

     Shopify stamps the customer with a market, not with where the visitor
     actually is, because Markets only cover UK and NL. Its own browsing-context
     endpoint knows the real country, so the form carries it as a tag.

     Two rules this must never break: it never blocks a sign-up, and it never
     delays one. Detection runs once at boot; if it has not answered by the time
     someone presses JOIN, the sign-up goes through with the plain tag and
     nothing is lost but the country. */
  var countryBound = false;
  function initCountryTag() {
    if (countryBound) return;
    var fields = document.querySelectorAll('form.newsletter-form input[name="contact[tags]"]');
    if (!fields.length) return;
    countryBound = true;
    fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true' +
          '&language%5Benabled%5D=true&currency%5Benabled%5D=true',
          { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var c = data && data.detected_values && data.detected_values.country;
        var handle = c && c.handle;
        var name = c && c.name;
        // a tag goes onto a customer record, so only ever an ISO country code
        // if (!handle || !/^[A-Z]{2}$/.test(handle)) return;
        if (!name) return;

        fields.forEach(function (f) {
          if (f.value.indexOf('country-') === -1) f.value += ', country-' + name;
        });

        // fields.forEach(function (f) {
        //   if (f.value.indexOf('country-') === -1) f.value += ', country-' + handle;
        // });
      })
      .catch(function () { /* no country is better than no sign-up */ });
  }

  /* Smooth scrolling used to live on `html`, which meant the browser applied it
     to its own jump to `#ContactFooter` when the sign-up form posted and came
     back. Reported by Pierre on 2026-09-07. It now belongs to the click, so the
     four "JOIN THE FIRST LISTEN LIST" links still glide and the return from a
     sign-up arrives instantly. */
  var anchorsBound = false;
  function initAnchorScroll() {
    if (anchorsBound) return;
    anchorsBound = true;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var hash = a.getAttribute('href');
      if (!hash || hash === '#') return;             // the localization menus use bare "#"
      var target = document.getElementById(hash.slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
      if (history.pushState) history.pushState(null, '', hash);
    });
  }

  /* "Need to add a back or close button to the privacy page."
     The link is rendered by the layout and always works as a link home;
     when the visitor actually arrived from the site, prefer a real step
     back so they land where they left off. */
  function initPolicyBack(root) {
    (root || document).querySelectorAll('a[data-brz-policy-back]').forEach(function (a) {
      if (a.hasAttribute('data-brz-bound')) return;
      a.setAttribute('data-brz-bound', '');
      a.addEventListener('click', function (e) {
        var sameSite = document.referrer && document.referrer.indexOf(location.origin) === 0;
        if (sameSite && history.length > 1) { e.preventDefault(); history.back(); }
      });
    });
  }

  function boot() {
    describeImages(document);
    initHeroChrome();
    tagFloats(document);
    tagReveals(document);
    initReveal();
    initSignupValidation(document);
    initCountryTag();
    initAnchorScroll();
    initPolicyBack(document);
    if (reduce.matches) {
      window.addEventListener('scroll', syncHeader, { passive: true });
      return;
    }
    collect();
    window.addEventListener('resize', collect);
    window.__brzFrame = frame;   // QA hook: force a frame when rAF is throttled
    sweepReveals(window.innerHeight);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    frame();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
